<template>
  <div class="">
      <p class="h3 text-dark font-weight-bold mb-1">
        {{session.name}}
      </p>
      <p class="mb-0">
        Session start date: <span class="ml-2 font-weight-bold">{{startDate}}</span>
      </p>
      <p class="mb-0">
        Session end date: <span class="ml-2 font-weight-bold">{{endDate}}</span>
      </p>
      <p class="mb-0">
        Today's date: <span class="ml-2 font-weight-bold">{{dateToday}}</span>
      </p>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'NeoCurrentSessionWidget',
  props: ['session'],
  computed: {
    startDate() {
      return moment(this.session.start_date).format('LL')
    },
    endDate() {
      return moment(this.session.end_date).format('LL')
    },
    dateToday() {
      return moment().format('LL')
    },
  },
}
</script>
